import { Resources } from '@shared/localizations/Resources';
import { sortColumnsBySortingInfo } from '@shared/utils/Table/TableColumnSorting';
export function createGroupByContextMenuItem(columns, groupByColumn, setGroupByColumn) {
    if (Resources.isHidden('panel.menu.GroupBy')) {
        return null;
    }
    const sortedGroupByColumns = sortColumnsBySortingInfo(columns.filter((column) => column.isAllowGrouping));
    const subitems = sortedGroupByColumns.map((column) => ({
        type: 'item',
        id: column.id,
        text: Resources.getResource(column.localizationKey),
        selected: (groupByColumn === null || groupByColumn === void 0 ? void 0 : groupByColumn.id) === column.id,
        onClick: () => ((groupByColumn === null || groupByColumn === void 0 ? void 0 : groupByColumn.id) === column.id ? setGroupByColumn(null) : setGroupByColumn(column))
    }));
    if (subitems.length === 0) {
        return null;
    }
    return {
        type: 'item',
        id: 'groupBy',
        text: Resources.getResource('panel.menu.GroupBy'),
        subitems: subitems
    };
}
